import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9007Handlers = [
  // パスワード再設定メール送信 /kymw9008/sendPasswordResetEmail
  http.post(PlessService.SERVICE.sendPasswordResetEmail.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.sendPasswordResetEmail.url, req);
    return HttpResponse.json(sendEmailSuccess);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const sendEmailSuccess = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}